import { FC, useMemo } from "react";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import DashboardSkeleton from "../Home/Skeleton/DashboardSkeleton";
import LoaderOverlay from "./LoaderOverlay";
import { useLocation } from "react-router-dom";
import CustomBoxWrapper from "../../components/CustomBoxWrapper/CustomBoxWrapper";

const Loading: FC = () => {
  const loadingSlice = useAppSelector((state) => state.LoadingSlice);
  const { pathname } = useLocation();

  const isHomeRoute = useMemo(
    () => ["/home", "/sso/old", "/pseudoLogin"].includes(pathname),
    [pathname],
  );

  if (!loadingSlice.showHideLoading) {
    return null; // Use null instead of empty fragment for better performance
  }

  if (isHomeRoute) {
    return (
      <CustomBoxWrapper>
        <DashboardSkeleton />
      </CustomBoxWrapper>
    );
  }

  return (
    <LoaderOverlay
      zIndex={3000}
      heading={
        loadingSlice.showOnboardingLoadingText
          ? "Crafting ABC experience for you"
          : "We're getting things ready for you"
      }
    />
  );
};

export default Loading;
